import { Modal } from '@lsq-frontend/common-ui';
import { AddUserPermissionsModalComponent } from './add-user-permissions-modal.component';
import { AddUserPersonalDetailsModalComponent } from './add-user-personal-details-modal.component';

export class AddUserModal extends Modal {
    public id = 'add-user-modal';
    public showFooter = true;
    public showCloseButton = true;
    public showOkButton = true;
    public width = '65.5rem';
}

export class AddUserPermissionsModal extends AddUserModal {
    public component = AddUserPermissionsModalComponent;
}

export class AddUserPersonalDetailsModal extends AddUserModal {
    public component = AddUserPersonalDetailsModalComponent;
}
